import { getChromeAlarms } from './chrome/wrappers';
import {
  CURRENT_SAFE_NETWORK_UPDATE_ALARM_NAME,
  onUpdateActiveSafeNetworkRetry,
} from './safeNetworks/safeNetworksProbe';

/**
 * Setup the callbacks for the scheduled alarms.
 *
 * This should be called as soon as possible to prevent race conditions.
 */
export const setupAlarmsCallbacks = (initializeData: () => Promise<void>) => {
  getChromeAlarms().onAlarm.addListener(async alarm => {
    // Safe Networks state retries
    if (alarm.name === CURRENT_SAFE_NETWORK_UPDATE_ALARM_NAME) {
      await initializeData();
      await onUpdateActiveSafeNetworkRetry();
    }
  });
};

/**
 * Creates an alarm that fires after a relative delay.
 * Uses delayInMinutes (relative) instead of when (absolute timestamp)
 * to avoid issues with manipulated device clocks.
 */
export const createAlarmWithDelay = (name: string, delayInMinutes: number) =>
  getChromeAlarms().create(name, { delayInMinutes });
